/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {accountUpdate} from '../api'

export const useMutationAccountUpdate = createReactQueryMutationHook('accountUpdate', accountUpdate)
